// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1UxDX","amount":"Amount_amount__2HJhs","tip":"Amount_tip__2XHUY","tipHeader":"Amount_tipHeader__2dgoW","tipsWrap":"Amount_tipsWrap__1RcNn"};